/* Otherworldly theme — interactions */
(function () {
  'use strict';

  /* Quantity steppers */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-qty-step]');
    if (!button) return;
    var input = button.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var step = parseInt(button.getAttribute('data-qty-step'), 10);
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = min;
    input.value = Math.max(min, current + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Product gallery */
  function showMedia(gallery, mediaId) {
    if (!gallery || !mediaId) return;
    var id = String(mediaId);
    var slides = gallery.querySelectorAll('[data-media-id]');
    var exists = Array.prototype.some.call(slides, function (slide) {
      return slide.getAttribute('data-media-id') === id;
    });
    if (!exists) return;
    slides.forEach(function (slide) {
      var active = slide.getAttribute('data-media-id') === id;
      slide.hidden = !active;
      if (!active) {
        slide.querySelectorAll('video').forEach(function (video) { video.pause(); });
      }
    });
    gallery.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.setAttribute('aria-current', thumb.getAttribute('data-thumb') === id ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-thumb]');
    if (!thumb) return;
    showMedia(thumb.closest('[data-gallery]'), thumb.getAttribute('data-thumb'));
  });

  /* 3D model viewer (Shopify-hosted 3D models on products) */
  function initModels() {
    if (!document.querySelector('model-viewer')) return;
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
    window.Shopify.loadFeatures([
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: function (errors) {
          if (errors) return;
          document.querySelectorAll('model-viewer').forEach(function (viewer) {
            try { new window.Shopify.ModelViewerUI(viewer); } catch (e) { /* ignore */ }
          });
        }
      }
    ]);
  }

  /* Variant picker */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var form = root.querySelector('[data-product-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceEl = root.querySelector('[data-price]');
    var addButton = root.querySelector('[data-add-button]');
    var addLabel = addButton ? addButton.querySelector('span') : null;
    var pickers = root.querySelectorAll('[data-option-index]');
    if (!pickers.length) return;

    function selectedValues() {
      var values = [];
      pickers.forEach(function (fieldset) {
        var index = parseInt(fieldset.getAttribute('data-option-index'), 10);
        var checked = fieldset.querySelector('input:checked');
        values[index] = checked ? checked.value : null;
        var label = fieldset.querySelector('[data-selected-value]');
        if (label && checked) label.textContent = checked.value;
      });
      return values;
    }

    function findVariant(values) {
      return data.variants.find(function (variant) {
        return variant.options.every(function (option, i) { return option === values[i]; });
      });
    }

    function markAvailability(values) {
      pickers.forEach(function (fieldset) {
        var index = parseInt(fieldset.getAttribute('data-option-index'), 10);
        fieldset.querySelectorAll('input').forEach(function (input) {
          var test = values.slice();
          test[index] = input.value;
          var match = findVariant(test);
          input.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }

    function update() {
      var values = selectedValues();
      var variant = findVariant(values);
      markAvailability(values);

      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          if (addLabel) addLabel.textContent = 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = variant.price_html;
      if (addButton) {
        addButton.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? data.add_label : 'Sold out';
      }
      if (variant.media_id) showMedia(root.querySelector('[data-gallery]'), variant.media_id);

      if (data.update_url && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      document.dispatchEvent(new CustomEvent('otherworldly:variant-change', {
        detail: { productId: String(data.id), variant: variant }
      }));
    }

    pickers.forEach(function (fieldset) { fieldset.addEventListener('change', update); });
    markAvailability(selectedValues());
  }

  /* Specs table follows the selected variant */
  document.addEventListener('otherworldly:variant-change', function (event) {
    var detail = event.detail;
    document.querySelectorAll('[data-specs-for="' + detail.productId + '"]').forEach(function (specs) {
      specs.querySelectorAll('[data-spec-option]').forEach(function (cell) {
        var index = parseInt(cell.getAttribute('data-spec-option'), 10);
        if (detail.variant.options[index] != null) cell.textContent = detail.variant.options[index];
      });
      specs.querySelectorAll('[data-spec-dims]').forEach(function (cell) {
        var dims = detail.variant.dimensions || cell.getAttribute('data-default') || '';
        cell.textContent = dims;
        var row = cell.closest('.specs-row');
        if (row) row.hidden = !dims;
      });
    });
  });

  /* Product recommendations */
  function initRecommendations() {
    document.querySelectorAll('[data-recommendations][data-url]').forEach(function (container) {
      fetch(container.getAttribute('data-url'))
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          var fresh = wrapper.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim().length) {
            container.innerHTML = fresh.innerHTML;
            container.hidden = false;
          }
        })
        .catch(function () { /* recommendations are optional */ });
    });
  }

  /* Collection sorting */
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-sort]');
    if (!select) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* Custom request form: show material only for 3D prints */
  function initRequestForms() {
    document.querySelectorAll('[data-request-panel]').forEach(function (panel) {
      var toggle = panel.querySelector('[data-kind-toggle]');
      if (!toggle) return;
      function sync() {
        var checked = toggle.querySelector('input:checked');
        var isPrint = !checked || checked.getAttribute('data-print') === 'true';
        if (isPrint) panel.removeAttribute('data-hide-print');
        else panel.setAttribute('data-hide-print', '');
      }
      toggle.addEventListener('change', sync);
      sync();
    });
  }

  /* Close mobile menu with Escape */
  document.addEventListener('keyup', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details.menu-drawer[open]').forEach(function (drawer) {
      drawer.removeAttribute('open');
      var summary = drawer.querySelector('summary');
      if (summary) summary.focus();
    });
  });

  function init() {
    document.querySelectorAll('[data-product]').forEach(initProduct);
    initModels();
    initRecommendations();
    initRequestForms();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Re-initialise sections when edited in the theme editor */
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-product]').forEach(initProduct);
    initRequestForms();
    initModels();
  });
})();
